import { LoadingButton } from "@mui/lab";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import PostHooks from "../../../Api/PostHooks";
import { Link, useNavigate } from "react-router-dom";
import AlertComponent from "../../../Components/AlertComponent";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const LoginForm = () => {
  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const username = watch("username");
  const password = watch("password");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [loading, , request] = PostHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const onSubmit = async (data) => {
    try {
      let formData = {
        username: data.username,
        password: data.password,
        channel_name: "mobile_number",
      };

      let props = {
        url: "/check_login",
        body: formData,
      };

      const response = await request(props);

      if (
        response &&
        response.status === 200 &&
        response.data.StatusCode === 0
      ) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Redirecting...",
        });

        // Use the 'data' from the form submission, which is always correct
        const userCredentials = {
          username: username,
          password: password,
          channel_name: "mobile_number",
        };

        navigate("/user-accounts", {
          state: {
            userAccounts: response.data.User,
            userCredentials, // Pass the correct, current credentials
          },
        });
      } else {
        const errorMessage =
          response?.data?.StatusMessage ??
          response?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Grid
        item
        xs={12}
        sx={{
          paddingTop: "20px",
        }}
      >
        <FormControl fullWidth error={!!errors.username}>
          {/* <MuiTelInput
            defaultCountry="KE"
            value={msisdn}
            disableFormatting
            onChange={(e) => setMsisdn(e)}
            required
          /> */}
          <InputLabel htmlFor="username">
            Enter National ID Number/Passport Number
          </InputLabel>
          <OutlinedInput
            id="username"
            type="text"
            {...register("username", {
              // required: true,
              maxLength: 11,
              minLength: 7,
            })}
            label="Enter National ID Number/Passport Number"
            value={username}
            // onChange={(e) => setUsername(e.target.value)}
            // onWheel={(event) => {
            //   event.target.blur();
            // }}
          />
          {errors.username && (
            <FormHelperText>Please enter a valid id number!</FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          paddingTop: "20px",
        }}
      >
        <FormControl fullWidth error={!!errors.password}>
          <InputLabel htmlFor="password">PIN</InputLabel>
          <OutlinedInput
            id="password"
            label="PIN"
            {...register("password")}
            value={password}
            required
            // onChange={(e) => {
            //   setPassword(e.target.value);
            // }}
            type={showPassword ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          {errors.password && (
            <FormHelperText>Enter your password</FormHelperText>
          )}
        </FormControl>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          mt: "10px",
          py: "10px",
          display: "flex",
          gap: "20px",
          justifyContent: "space-between",
        }}
      >
        {/* <Button
          fullWidth
          variant="outlined"
          onClick={() => navigate("/customer-registration")}
        >
          Register
        </Button> */}
        <LoadingButton
          variant="contained"
          color="primary"
          type="submit"
          loading={loading}
          fullWidth
        >
          Login
        </LoadingButton>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          pt: "10px",
          // display: "flex",
          // // gap: "20px",
          // justifyContent: "space-evenly",
          // alignItems: "flex-start",
        }}
      >
        {/* <Button
          variant="text"
          type="button"
          onClick={() => {
            navigate("/forgot-password");
          }}
        >
          Forgot password?
        </Button> */}
        {/* <Link variant="subtitle2" component={""} to={"/forgot-password"}>
          Forgot pin? Reset
        </Link> */}
        {/* </Grid>
      <Grid item xs={12}> */}
        <Typography variant="body2" align="">
          Don’t have an account?{" "}
          <Link
            variant="subtitle2"
            component={""}
            to={"/customer-registration"}
          >
            Get started
          </Link>
        </Typography>
      </Grid>
    </form>
  );
};

export default LoginForm;
